import { render, staticRenderFns } from "./AppointmentBookedByTimeBetweenAppointment.vue?vue&type=template&id=ae56fc7a"
import script from "./AppointmentBookedByTimeBetweenAppointment.vue?vue&type=script&lang=ts"
export * from "./AppointmentBookedByTimeBetweenAppointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports